import styled, { css } from 'styled-components';
import { margin, padding, pointer, borderRadius } from '@10d/tend-ui-styling';
import { Close } from '../../icons/Close/Close.js';

const Root = styled.span `
  display: inline-flex;
  align-items: center;
  gap: 4px;

  font-family: ${props => props.theme.fonts.museo};
  font-weight: 400;
  font-size: ${props => props.theme.fontSizes['12']};
  line-height: 16px;
  padding: 0 8px;

  color: ${props => props.$color};
  background-color: ${props => props.$backgroundColor};

  ${props => {
    if (props.$color || props.$backgroundColor)
        return css `
        color: ${props.$color || props.theme.colors.gray0};
        background-color: ${props.$backgroundColor || props.theme.colors.gray400};
      `;
    return {
        default: css `
        color: ${props.theme.colors.gray0};
        background-color: ${props.theme.colors.gray400};
      `,
        gray: css `
        color: ${props.theme.colors.gray0};
        background-color: ${props.theme.colors.gray650};
      `,
        blue: css `
        color: ${props.theme.colors.gray0};
        background-color: ${props.theme.colors.blue600};
      `,
        geekblue: css `
        color: ${props.theme.colors.gray0};
        background-color: ${props.theme.colors.geekblue600};
      `,
        green: css `
        color: ${props.theme.colors.gray0};
        background-color: ${props.theme.colors.green600};
      `,
        yellow: css `
        color: ${props.theme.colors.gray0};
        background-color: ${props.theme.colors.gold600};
      `,
        red: css `
        color: ${props.theme.colors.gray0};
        background-color: ${props.theme.colors.red600};
      `,
        cyan: css `
        color: ${props.theme.colors.gray0};
        background-color: ${props.theme.colors.cyan600};
      `,
        volcano: css `
        color: ${props.theme.colors.gray0};
        background-color: ${props.theme.colors.volcano600};
      `,
        purple: css `
        color: ${props.theme.colors.gray0};
        background-color: ${props.theme.colors.purple600};
      `,
        'gray-light': css `
        color: ${props.theme.colors.gray900};
        background-color: ${props.theme.colors['gray100-transparent']};
      `,
        'blue-light': css `
        color: ${props.theme.colors.gray900};
        background-color: ${props.theme.colors['blue200-transparent']};
      `,
        'geekblue-light': css `
        color: ${props.theme.colors.gray900};
        background-color: ${props.theme.colors['geekblue200-transparent']};
      `,
        'green-light': css `
        color: ${props.theme.colors.gray900};
        background-color: ${props.theme.colors['green200-transparent']};
      `,
        'yellow-light': css `
        color: ${props.theme.colors.gray900};
        background-color: ${props.theme.colors['gold200-transparent']};
      `,
        'red-light': css `
        color: ${props.theme.colors.gray900};
        background-color: ${props.theme.colors['red200-transparent']};
      `,
        'cyan-light': css `
        color: ${props.theme.colors.gray900};
        background-color: ${props.theme.colors['cyan200-transparent']};
      `,
        'volcano-light': css `
        color: ${props.theme.colors.gray900};
        background-color: ${props.theme.colors['volcano200-transparent']};
      `,
        'purple-light': css `
        color: ${props.theme.colors.gray900};
        background-color: ${props.theme.colors['purple200-transparent']};
      `,
    }[props.$preset];
}}
  ${margin};
  ${padding};
  ${pointer};
  ${borderRadius};
`;
const CloseIcon = styled(Close) `
  cursor: pointer;
`;

export { CloseIcon, Root };
//# sourceMappingURL=styled.js.map
